import { useEffect, useState } from 'react';
import '../assets/css/dialog.css';
import seleccionador from '../assets/img/gif/_seleccionador.gif'
import progress from '../assets/img/gif/progres.gif'





function Progress(props) {
    useEffect(() => {

    });
    return (
        <div class="dialog">
            <div class="progres"> 
                <img class="img-responsive" src={progress}></img>
            </div>
        </div>
    );
}

export default Progress;